// import React, { useEffect } from "react"
// import { Image } from "@cleartrip/bento"

// function ImageGrid(props) {
//   const { images } = props

//   useEffect(() => {
//     var lazyloadImages
//     var lazyloadThrottleTimeout
//     lazyloadImages = document.querySelectorAll(".lazy")

//     function lazyload() {
//       if (lazyloadThrottleTimeout) {
//         clearTimeout(lazyloadThrottleTimeout)
//       }

//       lazyloadThrottleTimeout = setTimeout(function () {
//         var scrollTop = window.pageYOffset
//         lazyloadImages.forEach(function (img) {
//           if (img.offsetTop < window.innerHeight + scrollTop) {
//             img.src = img.dataset.src
//             img.classList.remove("lazy")
//           }
//         })
//         if (lazyloadImages.length == 0) {
//           document.removeEventListener("scroll", lazyload)
//           window.removeEventListener("resize", lazyload)
//           window.removeEventListener("orientationChange", lazyload)
//         }
//       }, 20)
//     }

//     document.addEventListener("scroll", lazyload)
//     window.addEventListener("resize", lazyload)
//     window.addEventListener("orientationChange", lazyload)
//     lazyload()
//   }, [])

//   function constructPlaceHolder(images) {
//     return images.replace("f_auto", "e_blur:1000,q_1,f_auto")
//   }
//   const imageGrid = images.map((item, idx) => {
//     let dynamicWidth = 100 / images.length
//     item.placholder = constructPlaceHolder(item.src)
//     return (
//       <div style={{ width: `${dynamicWidth}%` }}>
//         <img
//           src={item.placholder}
//           width="100%"
//           data-src={item.src}
//           class="lazy"
//         />
//       </div>
//     )
//     return <img alt="Image" width="100%" height={700} src={item.src} />
//   })

//   return (
//     <div className="flex flex-row" width="100%">
//       {imageGrid}
//     </div>
//   )
// }

// export default ImageGrid

import React, { useEffect } from 'react'
import LazyImg from './LazyImg'

function ImageGrid({ images, innerMargin = 0, outterMargin = 0, handleClick }) {

    function constructPlaceHolder(images) {
        return images.replace('f_auto', 'w_176,e_blur:1000,c_scale,q_1,f_auto')
    }
    function handleClick(url){
        window.location.href = url
    }
    const numberOfImgs = images.length
    const imgWidth = ((1.0 / numberOfImgs) * 100).toString() + '%'
    const Images = images.map((ele, idx) => {
        ele.placholder = constructPlaceHolder(ele.src)
        return (
            <div
                style={{
                    width: imgWidth,
                    marginRight: idx < numberOfImgs - 1 && innerMargin
                }}
                key={idx}
            >
                {ele.url ? (
                    <span onClick={() => handleClick(ele.url)}>
                        <LazyImg src={ele.src} ph={ele.placholder} type={ele.type} width="100%" />
                    </span>
                ) : (
                    <LazyImg src={ele.src} ph={ele.placholder} type={ele.type} width="100%" />
                )}
            </div>
        )
    })

    return <div style={{ display: 'flex', margin: outterMargin }}>{Images}</div>
}

export default ImageGrid
